function count(self, substr) {
  var count = 0
  var pos = self.indexOf(substr)

  while (pos >= 0) {
    count += 1
    pos = self.indexOf(substr, pos + 1)
  }

  return count
}

module.exports = count


//////////////////
// WEBPACK FOOTER
// ./~/string/lib/_count.js
// module id = ./node_modules/string/lib/_count.js
// module chunks = 54